/**
 * Перечислення типів полів форми
 */
export enum FieldType {
    // Примітивні типи
    STRING = 'string',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    DATE = 'date',
    DATETIME = 'datetime',
    DATERANGE = 'daterange',
    DATETIMERANGE = 'datetimerange',
    EMAIL = 'email',
    PASSWORD = 'password',
    TEXTAREA = 'textarea',
    SELECT = 'select',
    RADIO = 'radio',
    RADIOGROUP = 'radiogroup',
    CHECKBOX = 'checkbox',
    SWITCH = 'switch',
    FILE = 'file',
    COLOR = 'color',
    MASKED = 'masked',
    TAGS = 'tags',
    EDITOR = 'editor',
    STATUS = 'status',

    // Складні типи
    ARRAY = 'array',
    OBJECT = 'object',
    TABLE = 'table',

    // Спеціальні типи
    COMPUTED = 'computed',
    CONDITIONAL = 'conditional',
}

/**
 * Визначення стратегій для різних типів полів
 */
export enum FieldStrategy {
    PRIMITIVE = 'primitive', // Прості типи даних
    ARRAY = 'array', // Масиви простих значень
    OBJECT = 'object', // Об'єкти з вкладеними полями
    TABLE = 'table', // Масиви об'єктів (таблиці)
}

/**
 * Функція обчислення значення поля
 * @param values - об'єкт з значеннями полів залежностей
 * @param formContext - контекст форми для доступу до інших полів
 */
export type ComputeFunction = (values: Record<string, any>, formContext?: any) => any

/**
 * Тип валідатора поля
 */
export type FieldValidator = (value: any, field?: any) => string | null | undefined

/**
 * Інтерфейс визначення поля
 */
export interface IFieldDefinition {
    name: string
    type: FieldType
    strategy: FieldStrategy
    label?: string
    defaultValue?: any
    isRequired?: boolean
    isMultiple?: boolean
    isEditable?: boolean
    isTranslatable?: boolean
    isDisableTransform?: boolean

    // Для об'єктів та таблиць
    fields?: Record<string, IFieldDefinition>

    // Для обчислювальних полів (COMPUTED)
    computeFn?: ComputeFunction
    dependencies?: string[] // Масив імен полів, від яких залежить обчислення

    // UI властивості
    inputProps?: Record<string, any>
    view?: (value: any, context: any) => any
    input?: (value: any) => any
    output?: (value: any) => any
    tooltip?: string // Текст підказки для іконки інформації

    // Для select та radio полів
    options?: Array<{ value: any; label: string; [key: string]: any }>

    // Валідація та доступ
    validators?: FieldValidator[]
    access?: any
    valueName?: string

    // Додаткові властивості
    props?: Record<string, any>
    depFn?: () => boolean
}
